import VueRouter from 'vue-router';

export default function (router: VueRouter, id: string | null) {
  id ? router.push({ name: 'Template', params: { id: id } }) : router.push({ name: 'NewTemplate' });
}
